// extracted by mini-css-extract-plugin
export default {"modal_wrapper":"BackgroundModal_modal_wrapper__6ZvM-","modal_title":"BackgroundModal_modal_title__vOJdz","modal_text":"BackgroundModal_modal_text__u2Juf"};